import React from 'react';
import { Tabs, Tab, Box, Button, Typography, TextField, Paper, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Grid, MenuItem, Dialog, DialogTitle, DialogContent } from '@mui/material';
import Client from '../Client';
import Config from '../ClientConfig';
import BackofficeReportsApi from './backofficeReportsApi';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

function formatIref(iref) {
  // Convert iref to string
  const irefStr = String(iref);
  // Calculate how many zeros to add to get length 7 (since 'K' is 1 char)
  const zerosNeeded = 7 - irefStr.length;
  // Create the zeros string
  const zeros = '0'.repeat(zerosNeeded > 0 ? zerosNeeded : 0);
  // Return concatenated string
  return 'K' + zeros + irefStr;
}

class PurchaseReceiptUI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: new Client ( "none" ),
      tabIndex: 0,
      isSubmitting: false,
      purchaseOrders: [],
      productEntries: [],
      orderData: {
        type: '',
        documentDate: '',
        promisedDate: '',
        location: '',
        description: '',
        supplier: '',
        PurchaseOrderProductEntry_po: []
      },
      psiData: [],
      selectedSupplier: '',
      tabs: ['NIR List', 'New NIR'], 
      selectedOrder: null,
      showDetailDialog: false,
      selectedSupplierFilter: '',
      selectedLocationFilter: '',
      location: 0,
      locations: [{'iref': 0, 'name': "Select Location"}],
      supplier: 0,
      suppliers: [{'iref': 0, 'name': "Select Supplier"}]
    };
    
    this.getData = this.getData.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.fetchPurchaseOrders = this.fetchPurchaseOrders.bind(this);
  }

  componentDidMount() {
    this.fetchPurchaseOrders();
    this.getData ();
  }

  fetchPurchaseOrders = (locationId = null, supplierId = null) => {
    const queryData = {
      "type": 1,
    };
    if (locationId) {
      queryData.location = locationId;
    }
    if (supplierId) {
      queryData.supplier = supplierId;
    }
    let data = this.state.client.getData(Config.API_URL_PURCHASE_ORDERS, queryData);
    if ( data ) {
      let checks = [];
      if (Array.isArray(data)) {
        checks = data;
      } else if (Array.isArray(data.purchaseOrder)) {
      checks = data.purchaseOrder;
    } else if (data.purchaseOrder) {
      checks = [data.purchaseOrder];
    }

      this.setState({ purchaseOrders: checks });
    }
  };

  getData () {
    let psiData = this.state.client.getData(Config.API_URL_PRODUCT_SUPPLIER_INFO, {"active": 1});
    if (psiData) {
      this.setState({ psiData: psiData });
    }
    let queryData = {
      // "centralSupply": 0,
      "status": 2,
      "isPurchased": 1,
      "orderBy_name": 1,
      // "supplier": 2
    };
    let data = this.state.client.getData(Config.API_URL_PRODUCT, queryData);
    if (data && psiData) {
      const fullProductsMap = {};
      data.products.forEach(product => {
        fullProductsMap[product.iref] = product;
      });
      const quantityMultiplierMap = {};
      psiData.productSupplierInfo.forEach(info => {
        if (info.preferred) {  // or your preferred logic
          quantityMultiplierMap[info.product.iref] = info.quantityMultiplier;
        }
      });
      const products = data.products.filter(p => p.centralSupply === 0) || {};
      const productEntries = Object.keys(products).map((key, index) => {
        const fData = data.products[key];
        // console.log('product unitType:', fData.unitType);
        return {
          productId: fData.iref,     // might be duplicated
          productName: fData.name,
          unit: fData.unitType,
          inputQuantity: '',
          quantity: '',
          reactKey: `${fData.iref}-${key}`,
          quantityMultiplier: quantityMultiplierMap[fData.iref] ?? 1  // default 1 if none
        };
      });
      this.setState({ fullProductsMap, products, productEntries });
    }
    else {
      alert('Failed to load products.');
    }
  
    let locations = BackofficeReportsApi.getLocations(this.state.client);
    this.setState ( { locations: locations.locations });
  };

  handleLocationFilterChange = (e) => {
    const locationId = e.target.value;
    this.setState({ selectedLocationFilter: locationId }, () => {
      this.fetchPurchaseOrders(
        this.state.selectedLocationFilter,
        this.state.selectedSupplierFilter
      );
    });
  };
  handleSupplierFilterChange = (e) => {
    const supplierId = e.target.value;
    this.setState({ selectedSupplierFilter: supplierId }, () => {
      this.fetchPurchaseOrders(
        this.state.selectedLocationFilter,
        this.state.selectedSupplierFilter
      );
    });
  };

  selectLocation = (event) => {
    this.setState (
      {location: event.target.value},
      function(){
        this.handleOrderChange('location', event.target.value);
      }
    );
  }
  selectSupplier = (event) => {
    const supplierIref = event.target.value;
    this.setState(
      { selectedSupplier: supplierIref },
      () => {
        // Call any function you want after state update
        this.handleSupplierChange(supplierIref);
      }
    );
  };

  handleSupplierChange = (supplierIref) => {
    const filteredProducts = this.state.psiData.productSupplierInfo
      .filter(item => {
        return (
          String(item.supplier?.iref) === String(supplierIref) &&
          (item.centralSupply === false || item.centralSupply === 0)
        );
      })
      .map(item => {
        const product = item.product;
        return {
          productId: product.iref,
          productName: product.name,
          unit: product.unitType ?? 0,
          quantityMultiplier: item.quantityMultiplier || 1, // ← fix is here
          inputQuantity: '',
          quantity: ''
        };
      })
      .sort((a, b) => a.productName.localeCompare(b.productName));
      
    this.setState({ productEntries: filteredProducts });
  };

  handleChange = (event, newValue) => {
    this.setState({ tabIndex: newValue });
  };

  handleOrderChange = (field, value) => {
    this.setState(prev => ({
      orderData: {
        ...prev.orderData,
        [field]: value,
      },
    }));
  };

  handleQuantityChange = (index, value) => {
    const productEntries = [...this.state.productEntries];
    const entry = productEntries[index];
    const v = String(value);                           // CHANGED
    // Allow intermediate states while typing: "", "-", trailing "." or ","
    if (v === '' || v === '-' || /[.,]$/.test(v)) {    // CHANGED
      entry.quantity = v;                               // CHANGED (keep as string temporarily)
    } else {
      if (Number(entry.unit) === 1) {
        // keep as string so trailing zeros are preserved while typing
        entry.quantity = v.replace(',', '.');
      } else {
        const n = parseFloat(v.replace(',', '.'));
        entry.quantity = isNaN(n) ? 0 : n;
      }
    }
    this.setState({ productEntries });
  }

  handleSubmit = () => {
    if (this.state.isSubmitting) return; 
    const { orderData, productEntries, client, selectedSupplier } = this.state;
    // Basic validation for required fields
    if (!orderData.promisedDate || !orderData.location) {
      alert('Please fill in both Date and Location before submitting.');
      return;  // stop submission
    }
    const filteredProducts = productEntries
      .filter(p => p.quantity && !isNaN(p.quantity) && parseFloat(p.quantity) !== 0)
      .map(p => ({
        product: p.productId,
        unit: p.unit,
        quantity: parseFloat(p.quantity)
      }));
      
    // Prevent submission if no valid lines
    if (filteredProducts.length === 0) {
      alert("Please enter at least one product line with quantity > 0.");
      return;
    }

    const now = new Date();
    const createdOn = now.toISOString();               // e.g. "2025-06-21T13:45:30.000Z"
    const type = 1;
    const supplier = selectedSupplier;

    const payload = {
      ...orderData,
      type,
      supplier,
      createdOn,
      PurchaseOrderProductEntry_po: filteredProducts
    };
    // console.log(JSON.stringify(payload));
    const result = this.state.client.pushData(Config.API_URL_PURCHASE_ORDERS, payload);
    if (result) {
      if (result && result.iref) {
        alert("NIR saved!");
        this.setState(prev => ({
          orderData: { type: 0, promisedDate: '', location: '', supplier: 0, description: '' },
          productEntries: prev.productEntries.map(p => ({ ...p, quantity: '', inputQuantity: '' })),
          location: 0,
          tabIndex: 0,
          isSubmitting: false
        }));
        this.fetchPurchaseOrders();
      } else {
        console.error('Save failed', result);
        const errorMessage = result.responseJSON?.message || "Save failed.";
        this.setState({ isSubmitting: false });
        alert(errorMessage);
      }
    } else {
      alert("Save failed: no response from server.");
    }

  };
  
  openOrderDetail = (po) => {
    this.setState({ selectedOrder: po, showDetailDialog: true });
  };

  closeOrderDetail = () => {
    this.setState({ showDetailDialog: false, selectedOrder: null });
  };

  renderNewOrderForm = () => {
    const { orderData, productEntries } = this.state;
    let locations = [{'iref': 0, 'name': "Select Location"}];
    if (this.state.locations){
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];
        let myData = {'iref': fData.iref, 'name': fData.name};
        locations.push ( myData );
      });
    }
    const unitTypeMap = { 0: 'pc', 1: 'kg' };
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');

    const minDateObj = new Date(today);
    minDateObj.setDate(minDateObj.getDate() - 30);
    const yyyyMin = minDateObj.getFullYear();
    const mmMin = String(minDateObj.getMonth() + 1).padStart(2, '0');
    const ddMin = String(minDateObj.getDate()).padStart(2, '0');
    const minDate = `${yyyyMin}-${mmMin}-${ddMin}`;

    const maxDateObj = new Date(today);
    maxDateObj.setDate(maxDateObj.getDate() + 30);
    const maxDate = `${yyyy}-${mm}-${dd}`;
    
    const localSuppliers = Object.values(
      this.state.psiData.productSupplierInfo
        .filter(item => item.centralSupply === false)
        .reduce((acc, item) => {
          const id = item.supplier?.iref;
          if (id && !acc[id]) {
            acc[id] = item.supplier;
          }
          return acc;
        }, {})
    );
    let suppliers = [{ iref: 0, name: "Select Supplier" }, ...localSuppliers];
    const { productSupplierInfo } = this.state.psiData;
    const { products } = this.state;  // full products list with all fields
    const supplierProductIds = new Set(
      productSupplierInfo
        .filter(psi => String(psi.supplier?.iref) === String(this.state.selectedSupplier))
        .map(psi => psi.product.iref)
    );
    const filteredProducts = products.filter(product => supplierProductIds.has(product.iref));

    return (
      <Paper
        elevation={1}
        sx={{
          p: { xs: 0.75, sm: 1 },
          height: '100%',
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '14px',
        }}
      >
        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <Grid
            container
            spacing={1}
            sx={{
              flexShrink: 0,
              mb: 0.75,
              px: 0.25,
              alignItems: 'center',
            }}
          >
            <Grid item xs={12} sm={6}>
              <TextField
                id="standard-select-location"
                select
                required
                // label="Select Location"
                defaultValue="0"
                // helperText="Select Location"
                variant="standard"
                sx={{
                  width: '100%',
                  '& .MuiInputBase-root': {
                    height: 34,
                    borderRadius: '12px',
                  },
                  '& .MuiInputBase-input': {
                    fontSize: {
                      xs: '16px',
                      sm: '0.84rem',
                    },
                  },
                }}
                onChange={this.selectLocation}
              >
                  {locations.map((option) => (
                  <MenuItem key={option.iref} value={option.iref}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                // label="Select Supplier"
                variant="standard"
                required
                value={this.state.selectedSupplier || 0}
                onChange={this.selectSupplier}
                fullWidth
                sx={{
                  width: '100%',
                  '& .MuiInputBase-root': {
                    height: 34,
                    borderRadius: '12px',
                  },
                  '& .MuiInputBase-input': {
                    fontSize: {
                      xs: '16px',
                      sm: '0.84rem',
                    },
                  },
                }}
              >
                {suppliers.map((supplier) => (
                  <MenuItem key={supplier.iref} value={supplier.iref}>
                    {supplier.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Select Date"
                value={orderData.promisedDate ? dayjs(orderData.promisedDate) : null}
                onChange={(newValue) => {
                  const formattedDate = newValue ? newValue.format('YYYY-MM-DD') : '';
                  this.setState(prev => ({
                    orderData: {
                      ...prev.orderData,
                      documentDate: formattedDate,
                      promisedDate: formattedDate,
                    }
                  }));
                }}
                minDate={dayjs(minDate)}
                maxDate={dayjs(maxDate)}
                inputFormat="DD.MM.YYYY"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"
                    sx={{
                      width: '100%',
                      '& .MuiInputBase-root': {
                        height: 34,
                        borderRadius: '12px',
                      },
                      '& .MuiInputBase-input': {
                        fontSize: {
                          xs: '16px',
                          sm: '0.84rem',
                        },
                      },
                    }}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
                required
              />
            </LocalizationProvider>
            </Grid>
          </Grid>
          {/* <Typography variant="subtitle1" gutterBottom>Products</Typography> */}
          <TableContainer
            component={Paper}
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: 'auto',
              borderRadius: '12px',
            }}
          >
            <Table
              size="small"
              stickyHeader
              sx={{
                minWidth: 420,
                tableLayout: 'fixed',
                '& .MuiTableCell-stickyHeader': {
                  backgroundColor: '#f8fafc',
                  zIndex: 3,
                },
                '& .MuiTableCell-root': {
                  py: { xs: 0.35, sm: 0.5 },
                  px: { xs: 0.4, sm: 0.6 },
                  fontSize: { xs: '0.72rem', sm: '0.84rem' },
                },
              }}
            >
              <TableHead sx={{'& .MuiTableCell-root': {fontWeight: 'bold'}}}>
                <TableRow>
                  <TableCell sx={{ py: 0.5, width: '50%', textAlign: 'left' }}>Product</TableCell>
                  <TableCell sx={{ py: 0.5, width: '20%', textAlign: 'center' }}>Unit</TableCell>
                  <TableCell sx={{ py: 0.5, width: '30%', textAlign: 'right' }}>Quantity</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productEntries
                  .filter(entry => supplierProductIds.has(entry.productId)) // or entry.iref, depending on your naming
                  .map((entry, index) => (
                    <TableRow key={entry.productId}>
                      <TableCell sx={{ py: 0.25, px: 0.5, width: '50%', whiteSpace: 'normal', textAlign: 'left' }}>
                        {entry.productName}
                      </TableCell>
                      <TableCell sx={{ py: 0.25, px: 0.5, width: '20%', whiteSpace: 'normal', textAlign: 'center' }}>
                        {unitTypeMap[entry.unit]}
                      </TableCell>
                      <TableCell sx={{ py: 0.25, px: 0.5, width: '30%', whiteSpace: 'normal', textAlign: 'right' }}>
                        <TextField
                          type="text"
                          inputMode="text"  // <— full keyboard on iOS, still fine on Android
                          // pattern={entry.unit === 1 ? "^-?[0-9]+([.,][0-9]{0,3})?$" : "^-?[0-9]+$"}
                          value={String(entry.quantity ?? '')}

                          onKeyDown={(e) => {
                            // Let users add/remove "-" anytime (mobile often blocks it)
                            if (e.key === '-' || e.key === 'Minus' || e.key === 'Subtract') {
                              e.preventDefault();
                              const cur = String(entry.quantity ?? '').replace(',', '.');

                              if (cur === '' || cur === '-') {
                                // start with just "-" so they can continue typing
                                this.handleQuantityChange(index, '-');
                              } else if (cur.startsWith('-')) {
                                // make positive
                                this.handleQuantityChange(index, cur.slice(1));
                              } else {
                                // make negative
                                this.handleQuantityChange(index, '-' + cur);
                              }
                            }
                          }}

                          onChange={(e) => {
                            const raw = e.target.value;

                            if (Number(entry.unit) === 1) {
                              // allow negatives + optional [, or .] + up to 3 decimals (incl. trailing dot/comma)
                              if (/^-?\d*(?:[.,]\d{0,3})?$/.test(raw)) {
                                this.handleQuantityChange(index, raw.replace(',', '.'));
                              }
                            } else {
                              if (/^-?\d*$/.test(raw)) {
                                this.handleQuantityChange(index, raw);
                              }
                            }
                          }}

                          onBlur={(e) => {
                            let v = e.target.value.replace(',', '.');
                            if (v === '' || v === '-') return this.handleQuantityChange(index, '');
                            if (Number.isNaN(Number(v))) return;

                            if (Number(entry.unit) === 1) {
                              // ✅ keep text form, allow trailing zeros up to 3
                              const m = v.match(/^(-?\d+)(?:[.,](\d{0,3}))?$/);
                              if (m) {
                                const intPart = m[1];
                                const decPart = m[2] ?? '';
                                const out = decPart ? `${intPart}.${decPart}` : intPart;
                                this.handleQuantityChange(index, out);
                              }
                            } else {
                              // integers as before
                              const n = parseInt(v, 10);
                              if (!isNaN(n)) this.handleQuantityChange(index, String(n));
                            }
                          }}

                          inputProps={{
                            step: entry.unit === 1 ? '0.001' : '1', // kg: 0.001; pcs: 1
                            // inputMode: entry.unit === 1 ? 'decimal' : 'numeric',
                            style: { textAlign: 'right' },
                            pattern: Number(entry.unit) === 1
                              ? "^-?[0-9]+([.,][0-9]{0,3})?$"
                              : "^-?[0-9]+$",
                          }}

                          InputProps={{
                            sx: {
                              py: 0.2,
                              height: 30,
                              width: { xs: 76, sm: 110 },
                              fontSize: { xs: '1rem', sm: '0.9rem' },
                              backgroundColor: entry.unit === 1 ? '#e6f7ff' : 'inherit',
                            },
                          }}
                        />
                      </TableCell>
                      {/* <TableCell sx={{ py: 0.25, px: 0.5, width: '20%', whiteSpace: 'normal', textAlign: 'right' }}>
                        <TextField
                          type="number"
                          size="small"
                          value={entry.inputQuantity}
                          onChange={(e) => this.handleQuantityChange(index, e.target.value)}
                          inputProps={{
                            step: '0.001',
                            inputMode: 'decimal',
                            // min: 0,
                            style: { textAlign: 'right' },
                          }}
                          InputProps={{
                            sx: {
                              py: 0.2,
                              height: '32px',
                              width: '90px',
                              fontSize: '1rem',
                              backgroundColor: entry.quantityMultiplier > 1 ? '#fff3cd' : 'inherit',
                            },
                          }}
                        />
                      </TableCell> */}
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Button
            variant="contained"
            color="primary"
            sx={{
              flexShrink: 0,
              mt: 0.75,
              minWidth: { xs: '100%', sm: 200 },
              width: { xs: '100%', sm: 'fit-content' },
              alignSelf: 'center',
              px: 3,
              height: 34,
              borderRadius: '12px',
              textTransform: 'none',
              fontWeight: 750,
            }}
            onClick={this.handleSubmit}
            disabled={this.state.isSubmitting}
          >
            Save NIR
          </Button>
        </Box>
      </Paper>
    );
  };

  renderOrderList = () => {
    // console.log(this.state.purchaseOrders);
    let locations = [{'iref': 0, 'name': "Select Location"}];
    if (this.state.locations){
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];
        let myData = {'iref': fData.iref, 'name': fData.name};
        locations.push ( myData );
      });
    }
    const localSuppliers = Object.values(
      (this.state.psiData?.productSupplierInfo || [])
        .filter(item => item.centralSupply === false)
        .reduce((acc, item) => {
          const id = item.supplier?.iref;
          if (id && !acc[id]) {
            acc[id] = item.supplier;
          }
          return acc;
        }, {})
    );
    let suppliers = [{ iref: 0, name: "Select Supplier" }, ...localSuppliers];
    return (
      <Paper
        elevation={1}
        sx={{
          p: { xs: 0.75, sm: 1 },
          height: '100%',
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '14px',
        }}
      >
        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          {/* <Typography variant="h6">Purchase Orders</Typography> */}
          <Grid
            container
            spacing={1}
            sx={{
              flexShrink: 0,
              mb: 0.75,
              px: 0.25,
              alignItems: 'center',
            }}
          >
            <Grid item xs={12} sm={6}>
              <TextField 
                id="standard-select-location"
                select
                required
                // label="Select Location"
                defaultValue="0"
                // helperText="Select Location"
                variant="standard"
                sx={{
                  width: '100%',
                  pl: 0,
                  '& .MuiInputBase-root': {
                    height: 34,
                    borderRadius: '12px',
                  },
                  '& .MuiInputBase-input': {
                    fontSize: {
                      xs: '16px',
                      sm: '0.84rem',
                    },
                  },
                }}
                onChange={this.handleLocationFilterChange}
              >
                  {locations.map((option) => (
                  <MenuItem key={option.iref} value={option.iref}>
                    {option.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                // label="Select Supplier"
                variant="standard"
                required
                value={this.state.selectedSupplierFilter || 0}
                onChange={this.handleSupplierFilterChange}
                fullWidth
                sx={{
                  width: '100%',
                  '& .MuiInputBase-root': {
                    height: 34,
                    borderRadius: '12px',
                  },
                  '& .MuiInputBase-input': {
                    fontSize: {
                      xs: '16px',
                      sm: '0.84rem',
                    },
                  },
                }}
              >
                {suppliers.map((supplier) => (
                  <MenuItem key={supplier.iref} value={supplier.iref}>
                    {supplier.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid> 
          <TableContainer
            component={Paper}
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: 'auto',
              borderRadius: '12px',
            }}
          >
            <Table
              size="small"
              stickyHeader
              sx={{
                tableLayout: 'fixed',
                width: '100%',
                '& .MuiTableCell-stickyHeader': {
                  backgroundColor: '#f8fafc',
                  zIndex: 3,
                },
                '& .MuiTableCell-root': {
                  py: { xs: 0.45, sm: 0.65 },
                  px: { xs: 0.5, sm: 0.9 },
                  fontSize: { xs: '0.74rem', sm: '0.86rem' },
                },
              }}
            >
              <TableHead sx={{'& .MuiTableCell-root': {fontWeight: 'bold'}}}>
                <TableRow>
                  <TableCell sx={{ py: 0.5, textAlign: 'center' }}>NIR</TableCell>
                  <TableCell sx={{ py: 0.5 }}>Date</TableCell>
                  <TableCell sx={{ py: 0.5 }}>Location</TableCell>
                  <TableCell sx={{ py: 0.5 }}>Supplier</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(this.state.purchaseOrders || []).map((po, idx) => (
                  <TableRow key={idx} onClick={() => this.openOrderDetail(po)} style={{ cursor: 'pointer' }}>
                    <TableCell sx={{ py: 0.5, textAlign: 'center' }}>
                      {/* {po.location?.iref && po.iref ? `${po.location.iref}-${po.iref}` : '-'} */}
                      {formatIref(po.iref)}
                    </TableCell>
                    <TableCell sx={{ py: 0.5 }}>{po.documentDate}</TableCell>
                    <TableCell sx={{ py: 0.5 }}>{po.location?.name || po.location?.uid || '-'}</TableCell>
                    <TableCell sx={{ py: 0.5 }}>{po.supplier?.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>
    );
  };

  renderOrderDetailDialog = () => {
    const { selectedOrder } = this.state;
    if (!selectedOrder) return null;
    const unitTypeMap = { 0: 'pc', 1: 'kg' };
    // console.log(selectedOrder);
    return (
      <Dialog open={this.state.showDetailDialog} onClose={this.closeOrderDetail} maxWidth="md" fullWidth>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Order Detail - {selectedOrder.iref || selectedOrder.id}
          <IconButton
            aria-label="close"
            onClick={this.closeOrderDetail}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography>Date: {selectedOrder.documentDate}</Typography>
          <Typography>NIR: {formatIref(selectedOrder.iref)}</Typography>
          <Typography>Location: {selectedOrder.location?.name || '-'}</Typography>
          <Typography>Supplier: {selectedOrder.supplier?.name || '-'}</Typography>

          {selectedOrder.PurchaseOrderProductEntry_po?.length > 0 && (
            <Box mt={2}>
              {/* <Typography variant="subtitle1">Products</Typography> */}
              <Table size="small">
                <TableHead sx={{'& .MuiTableCell-root': {fontWeight: 'bold'}}}>
                  <TableRow>
                    <TableCell>Product</TableCell>
                    <TableCell sx={{ textAlign: 'center' }}>Unit</TableCell>
                    <TableCell sx={{ textAlign: 'right' }}>Quantity</TableCell>
                    {/* <TableCell>AccountingQty</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                {[...selectedOrder.PurchaseOrderProductEntry_po]
                  .sort((a, b) => {
                    const nameA = this.state.fullProductsMap[a.product.iref]?.name || '';
                    const nameB = this.state.fullProductsMap[b.product.iref]?.name || '';
                    return nameA.localeCompare(nameB);
                  })
                  .map((line, idx) => {
                    const product = this.state.fullProductsMap[line.product.iref] || {};
                    return (
                      <TableRow key={idx}>
                        <TableCell>{product.name || line.product.iref || '-'}</TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>
                          {unitTypeMap[product.unitType] || '-'}
                        </TableCell>
                        <TableCell sx={{ textAlign: 'right' }}>
                          {line.quantity.toLocaleString()}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
              </Table>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    );
  };

  render() {
    const { tabIndex, tabs } = this.state;

    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          maxHeight: '100%',
          minHeight: 0,
          minWidth: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.default',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            flexShrink: 0,
            borderRadius: '12px',
            border: '1px solid rgba(15, 23, 42, 0.08)',
            overflow: 'hidden',
            mb: 0.75,
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={this.handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              minHeight: { xs: 36, sm: 40 },
              '& .MuiTabs-indicator': {
                height: 2,
              },
              '& .MuiTab-root': {
                minHeight: { xs: 36, sm: 40 },
                textTransform: 'none',
                fontWeight: 700,
                fontSize: { xs: '0.75rem', sm: '0.84rem' },
                px: { xs: 1, sm: 1.4 },
              },
            }}
          >
            {tabs.map((label, idx) => (
              <Tab key={idx} label={label} />
            ))}
          </Tabs>
        </Paper>

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          {tabIndex === 0 ? this.renderOrderList() : this.renderNewOrderForm()}
        </Box>

        {this.renderOrderDetailDialog()}
      </Box>
    );
  }
}

export default PurchaseReceiptUI;
